// @core/api/endpoints/project/delete_milestone.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/project';

/**
 * Delete milestone
 * Deletes a milestone from the project. Items linked to the milestone are unlinked but not removed from the project.
 */
export async function DeleteMilestone(
  project_id: string,
  milestone_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id/milestones/:milestone_id`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  requestPath = requestPath.replace(':milestone_id', encodeURIComponent(milestone_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
